import { NgModule } from '@angular/core';
import { MicrobiologyGridColumns } from './microbiology-grid-columns';
import { MicrobiologyStorage } from './microbiology-storage';
import { CovanceFilterModule } from '../../covance-filter/covance-filter.module';
import { MicrobiologyComponent } from './microbiology.component';
import { SharedModule } from '../../shared/shared.module';
import * as Covanceaggridmodule from '../../covance-ag-grid/covance-ag-grid.module';
import { MicrobiologyResultAgRendererComponent } from './microbiology-result-ag-renderer.component';
import { CultureDetailsAgRendererComponent } from './culture-details-ag-renderer.component';
import { LegendModule } from '../../legend/legend.module';
import { CultureGroupAgRendererComponent } from './culture-group-ag-renderer.component';
import { CorporateModule } from '../../corporate/corporate.module';
import { MicrobiologyColumns } from './microbiology-columns';

@NgModule({
    imports: [
        SharedModule,
        Covanceaggridmodule.CovanceAgGridModule,
        CovanceFilterModule,
        LegendModule,
        CorporateModule
    ],
    declarations: [
        MicrobiologyComponent,
        MicrobiologyResultAgRendererComponent,
        CultureDetailsAgRendererComponent,
        CultureGroupAgRendererComponent
    ],
    exports: [
        MicrobiologyComponent,
    ],
    providers: [
        MicrobiologyStorage,
        MicrobiologyGridColumns,
        MicrobiologyColumns
    ],
    entryComponents: [
        MicrobiologyResultAgRendererComponent,
        CultureDetailsAgRendererComponent,
        CultureGroupAgRendererComponent
    ]
})
export class MicrobiologyDataModule { }